import { LinkableEntityType } from '@api';
import { Anchor } from '@common';

type PersonAnchorPropsType = {
  person: LinkableEntityType;
  children?: React.ReactNode;
};

export const PersonAnchor: React.FC<PersonAnchorPropsType> = ({
  person,
  children,
}) => {
  return (
    <Anchor key={person.id} to={`/persons/$id`} params={{ id: person.id }}>
      {children ?? person.name}
    </Anchor>
  );
};
